import React, { useEffect, useState, useContext, useRef } from "react";
import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import "./home.css";
import MockupEssen from "../../img/mockup_essen.jpg";
import MockupCatering from "../../img/mockup_catering.jpg";
import MockupFacility from "../../img/mockup_facility.jpg";
import LogoEnkelwirtschaft from "../../img/enkelwirtschaft.png";
import Meeting from "../../img/meeting.png";
import benefitsimg from "../../img/benfitsme_neu.png";
import BeitragIcon from "../../img/beitrag.png";
import Beitrag from "../../img/beitrag.png";
import OpenInNewOutlined from "@material-ui/icons/OpenInNewOutlined";
import EditIcon from "@material-ui/icons/Edit";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { DataContext } from "../../context/DataContext";

const useStyles = makeStyles((theme) => ({
  root: {
    // height:"100%",
    padding: "0px",
    display: "grid",
    gridTemplateColumns: "50% 50%",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "100%",
    },
  },
  griditem: {
    padding: "10px",
    width: "100%",
  },
  section_title: {
    // border: "1px solid #000",
    color: "#fff",
    textTransform: "uppercase",
    fontSize: "14px",
    marginBottom: "10px",
  },
  rounded_corner_right: {
    // border: "1px solid #000",
    backgroundColor: "#ffffff",
    borderRadius: "0px 10px 0px 0px",
    height: "12px",
    width: "100%",
    opacity: 0.8,
  },
  rounded_corner_left: {},
  DA_info_container: {
    // border: "1px solid #f0f",
    width: "100%",
    padding: "2px 10px 8px 10px",
    backgroundColor: "#ffffff",
    color: "#000000",
    opacity: 0.8,
  },

  DA_box: {
    marginBottom: "8px",
    // width: "90%",
    border: "1px solid #fff",
    backgroundColor: "#ffffff",

    padding: "10px",
  },

  DA_box_highlight: {
    border: "1px solid #55ba5e",
    backgroundColor: "#ffffff",
    padding: "10px",

    // width: "100%",
  },
  DA_info_row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  DA_info_name: {
    backgroundColor: "#55ba5e",
    color: "#fff",
    padding: "3px",
    width: "70%",
  },
  DA_info_date: {
    color: "#323232",
    fontWeight: "bold",
  },
  DA_info_checkbox: {},
  box_footer: {
    display: "flex",
    justifyContent: "flex-end",
    // fontWeight: "bold",
    padding: "0px 35px",
    alignItems: "center",
    // border: "1px solid #000",
    height: "30px",
    backgroundColor: "#d0e5d9",
    borderRadius: "0px 0px 0px 10px",
    width: "100%",
    // color:"#55ba5e"
  },
}));

function showModal() {
  let modal = document.getElementById("myModal");
  modal.style.display = "block";
}

export default function Home() {
  const { appToken, appLoggedInChange, appLoggedIn } = useContext(DataContext);

  const [spacing, setSpacing] = React.useState(2);
  const classes = useStyles();
  const [branchennews, setBranchennews] = useState();
  const [kurznachrichten, setKurznachrichten] = useState();
  const [updates, setUpdates] = useState([]);
  const [updatesHTML, setUpdatesHTML] = useState(null);
  const [typ, setTyp] = useState();
  const [Cateringnews, setCateringnews] = useState();
  const [Reinigungnews, setReinigungnews] = useState();

  const [searchString, setSearchString] = useState("");
  const [accCatering, setAccCatering] = useState(null);

  const [newsText, setNewsText] = useState("");
  const [newsId, setNewsId] = useState(null);

  const [headline, setheadline] = useState("");
  const [link, setLink] = useState("");
  const [news, setNews] = useState();
  const [user, setUser] = useState();
  const [countTopic, setCountTopic] = useState(0);
  const [editMode, setEditMode] = useState(false);

  const [valueLink, setValueLink] = useState("");
  // upload file
  // const [selectFile, setSelectFile] = useState();
  const [uploadFile, setUploadFile] = useState();

  function showEditModal(nachricht) {
    setEditMode(true);
    // console.log("editor", ClassicEditor.setData(`<p>hallo</p>`))

    // console.log("nachricht zum editieren", nachricht)

    let modal = document.getElementById("myModal");
    let tempHeadline = nachricht.nachrichten_text;
    // tempHeadline = tempHeadline.split('[LINK]')
    // tempHeadline = tempHeadline[0].substr(7);
    // console.log(tempHeadline)

    setheadline(nachricht.nachrichten_headline);
    setNewsText(tempHeadline);
    if (nachricht.nachrichten_link !== null) {
      setValueLink(nachricht.nachrichten_link);
    }
    setNewsId(nachricht.nachrichten_id);

    // editor.setData(nachricht.nachrichten_text)

    modal.style.display = "block";
  }

  function count(event) {
    let limit = 35;
    // console.log("tz",tempZahl)
    // console.log(event.target.value.length)
    let berechnung = limit - event.target.value.length;

    if (berechnung >= 0) {
      setCountTopic(event.target.value.length);
      setValueTopic(event.target.value);
      setheadline(event.target.value);
    }
  }
  function changeLink(event) {
    let limit = 200;
    // console.log("tz",tempZahl)
    // console.log(event.target.value.length)
    let berechnung = limit - event.target.value.length;

    if (berechnung >= 0) {
      setCountLink(event.target.value.length);
      setValueLink(event.target.value);
      setLink(event.target.value);
    }
  }

  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      //  console.log(editorRef.current.replace(/(<([^>]+)>)/gi, ""))
      console.log(
        editorRef.current.getContent().replace(/(<([^>]+)>)/gi, "").length
      );
    }
  };

  function getNews() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ` + appToken);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
    };

    fetch(
      "https://intranet-backend.procuratio.com/api_v2/get_nachrichten.php",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => setNews(result))
      .catch((error) => {
        appLoggedInChange(false);
        appTokenChange("init");
        localStorage.removeItem("prc_token");
        console.log("error", error);
      });
  }

  useEffect(() => {
    if (appLoggedIn === true && appToken != "init") {
      setUser(localStorage.getItem("prc_ldap_username"));

      //getNews()

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ` + appToken);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
      };

      fetch(
        "https://intranet-backend.procuratio.com/api_v2/get_nachrichten.php",
        requestOptions
      )
        .then((response) => {
          if (response.status !== 200) {
            throw "fehler";
          }
          return response.json();
        })
        .then((result) => setNews(result))
        .catch((error) => {
          appLoggedInChange(false);
          appTokenChange("init");
          localStorage.removeItem("prc_token");
          console.log("error", error);
        });

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ` + appToken);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
      };

      fetch(
        "https://intranet-backend.procuratio.com/api_v2/get_updates.php",
        requestOptions
      )
        .then((response) => {
          if (response.status !== 200) {
            throw "fehler";
          }
          return response.json();
        })
        .then((result) => setUpdates(result))
        .catch((error) => {
          appLoggedInChange(false);
          appTokenChange("init");
          localStorage.removeItem("prc_token");
          console.log("error", error);
        });

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ` + appToken);
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      fetch(
        "https://intranet-backend.procuratio.com/api_v2/g_qm_cat.php",
        requestOptions
      )
        .then((response) => {
          if (response.status !== 200) {
            throw "fehler";
          }
          return response.json();
        })
        .then((result) => {
          setAccCatering([result.data]);
        })
        .catch((error) => {
          appLoggedInChange(false);
          appTokenChange("init");
          localStorage.removeItem("prc_token");
          console.log("error", error);
        });

      // setUser(localStorage.getItem("ldap_username"));

      // var requestOptions = {
      //   method: "GET",
      //   redirect: "follow",
      //   credentials: "same-origin",
      //   headers: {
      //     Authorization: "Bearer " + token,
      //   },
      // };

      // fetch(
      //   "https://intranet-backend.procuratio.com/get_nachrichten.php",
      //   requestOptions
      // )
      //   .then((response) => response.json())
      //   .then((result) => setQMnews(result))
      //   .catch((error) => console.log("error", error));
    }
  }, [appLoggedIn, appToken]);

  useEffect(() => {
    if (news && news[0]) {
      /* Kurznachrichten  */
      setKurznachrichten(
        news.map((nachricht) => {
          if (nachricht.nachrichten_typ == 4) {
            return (
              <>
                <div
                  style={{
                    backgroundColor: "#e8f2ec",
                    border: "1px solid #fff",
                    marginBottom: "5px",
                  }}
                  key={nachricht.nachrichten_id}
                >
                  <div
                    style={{
                      padding: "1px",
                      display: "flex",
                      width: "100%",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        padding: "3px 8px",
                        color: "#55ba5e",
                        fontWeight: "bold",
                      }}
                    >
                      {(() => {
                        if (nachricht.nachrichten_text === "undefined") {
                          return nachricht.nachrichten_headline;
                        } else {
                          return (
                            <Link
                              style={{ color: "#55ba5e" }}
                              to={"nachricht/" + nachricht.nachrichten_id}
                            >
                              {nachricht.nachrichten_headline}
                              <OpenInNewOutlined
                                style={{ fontSize: "smaller" }}
                              />
                            </Link>
                          );
                        }
                      })()}
                    </div>
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "smaller",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        flexWrap: "no-wrap",
                        width: "100%",
                      }}
                    >
                      <div style={{ padding: "3px 8px" }}>
                        {nachricht.nachrichten_user}
                      </div>
                      <div style={{ padding: "3px 8px" }}>
                        {" "}
                        {nachricht.nachrichten_user === user ? (
                          <span onClick={() => showEditModal(nachricht)}>
                            <EditIcon
                              style={{ color: "darkgreen", fontSize: "large" }}
                            />
                          </span>
                        ) : (
                          ""
                        )}
                        {nachricht.nachrichten_datum.split(" ")[0]}
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "100%", padding: "3px 8px" }}></div>
                </div>
              </>
            );
          }
        })
      );

      /* Branchennews  */
      setBranchennews(
        news.map((nachricht) => {
          if (nachricht.nachrichten_typ == 1) {
            return (
              <>
                <div
                  style={{
                    backgroundColor: "#e8f2ec",
                    border: "1px solid #fff",
                    marginBottom: "5px",
                  }}
                  key={nachricht.nachrichten_id}
                >
                  <Link
                    to={"/nachricht/" + nachricht.nachrichten_id}
                    className="a_header"
                  >
                    <div
                      style={{
                        padding: "10px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          padding: "3px 8px",
                          color: "#55ba5e",
                          fontWeight: "bold",
                        }}
                      >
                        {nachricht.nachrichten_headline}
                      </div>
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: "smaller",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "flex-end",
                          flexWrap: "no-wrap",
                        }}
                      >
                        <div style={{ padding: "3px 8px" }}>
                          {nachricht.nachrichten_user}
                        </div>
                        <div style={{ padding: "3px 8px" }}>
                          {/* <span onClick={() => showEditModal(nachricht)}>
                          <EditIcon
                                
                                style={{ color: 'darkgreen', fontSize: "large" }}
                                
                              />
                              </span> */}
                          {nachricht.nachrichten_datum}
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </>
            );
          }
        })
      );

      setCateringnews(
        news.map((nachricht) => {
          if (nachricht.nachrichten_typ == 2) {
            return (
              <>
                <div
                  style={{
                    backgroundColor: "#e8f2ec",
                    border: "1px solid #fff",
                    marginBottom: "5px",
                  }}
                  key={nachricht.nachrichten_id}
                >
                  <div
                    style={{
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        padding: "3px 8px",
                        color: "#55ba5e",
                        fontWeight: "bold",
                      }}
                    >
                      <Link
                        to={"/nachricht/" + nachricht.nachrichten_id}
                        className="a_header"
                      >
                        {nachricht.nachrichten_headline}
                      </Link>
                    </div>
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "smaller",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        flexWrap: "no-wrap",
                      }}
                    >
                      <div style={{ padding: "3px 8px" }}>
                        {nachricht.nachrichten_user}
                      </div>
                      <div style={{ padding: "3px 8px" }}>
                        {/* <span onClick={() => showEditModal(nachricht)}>
                          <EditIcon
                                
                                style={{ color: 'darkgreen', fontSize: "large" }}
                                
                              /></span> */}
                        {nachricht.nachrichten_datum}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          }
        })
      );

      setReinigungnews(
        news.map((nachricht) => {
          if (nachricht.nachrichten_typ == 3) {
            return (
              <>
                <div
                  style={{
                    backgroundColor: "#e8f2ec",
                    border: "1px solid #fff",
                    marginBottom: "5px",
                  }}
                  key={nachricht.nachrichten_id}
                >
                  <Link
                    to={"/nachricht/" + nachricht.nachrichten_id}
                    className="a_header"
                  >
                    <div
                      style={{
                        padding: "10px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          padding: "3px 8px",
                          color: "#55ba5e",
                          fontWeight: "bold",
                        }}
                      >
                        {nachricht.nachrichten_headline}
                      </div>
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: "smaller",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "flex-end",
                          flexWrap: "no-wrap",
                        }}
                      >
                        <div style={{ padding: "3px 8px" }}>
                          {nachricht.nachrichten_user}
                        </div>
                        <div style={{ padding: "3px 8px" }}>
                          {nachricht.nachrichten_datum}
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </>
            );
          }
        })
      );
    }
  }, [news]);

  useEffect(() => {
    updates.length>0 ?
    setUpdatesHTML(
      
        updates.map(
          (update) => {
          return(<div className={classes.DA_info_container} key={"update_"+update.updates_id}>
            <div className={classes.DA_box_highlight}>
              <div
                className={classes.DA_info_row}
                style={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  backgroundColor: "orange",
                }}
              >
                <div
                  className={classes.DA_info_name}
                  style={{
                    fontWeight: "bold",
                    fontSize: "12px",
                    backgroundColor: "orange",
                  }}
                >
                  Neue {update.updates_typ} unter {update.updates_kategorie}
                </div>
                <div style={{ color: "white" }}>{update.updates_datum}</div>
              </div>
              <div className="headline">
                {
                  update.updates_kategorie === "Enkelwirtschaft" ? <img src={LogoEnkelwirtschaft} style={{ maxHeight: "40px" }} /> : null
                }
                {
                  update.updates_kategorie === "Besprechung" ? <img src={Meeting} style={{ maxHeight: "40px" }} /> : null
                }
                {
                  update.updates_kategorie === "QM" ? <img src={Beitrag} style={{ maxHeight: "40px" }} /> : null
                }
                {
                  update.updates_kategorie === "Benefits" ? <img src={benefitsimg} style={{ maxHeight: "40px" }} /> : null
                }

                <a
                  style={{ padding: "5px" }}
                  href={update.updates_link}
                >
                  {update.updates_text}
                </a>
              </div>
            </div>
          </div>)
          
        }
        )
    )
    : null
  }, [updates]);

  function closeModal() {
    // let span=document.getElementsByClassName("close")[0];
    let modal = document.getElementById("myModal");

    modal.style.display = "none";
  }

  async function sendBeitrag(beitrag) {
    var formdata = new FormData();
    formdata.append("headline", beitrag.headline);
    formdata.append("text", beitrag.text);
    formdata.append("typ", beitrag.typ);
    formdata.append("user", beitrag.user);
    formdata.append("file", uploadFile);
    formdata.append("link", beitrag.link);
    formdata.append("newsId", beitrag.newsId);

    var requestOptions = {
      method: "POST",
      redirect: "follow",
      credentials: "include",
      headers: {
        Authorization: "Bearer " + appToken,
      },
    };

    fetch(
      "https://intranet-backend.procuratio.com/create_nachricht.php",
      requestOptions
    )
      //   .then(response => response.text())
      .then((response) => getNews())
      .catch((error) => {
        appLoggedInChange(false);
        console.log("error", error);
      });
  }

  const handleChange = (e, editor) => {
    const data = editor.getData();
    setNewsText(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let beitrag = {
      typ: 4,
      headline: headline,
      text: newsText,
      user: user,
      link: link,
      newsId: newsId !== null ? newsId : null,
    };

    sendBeitrag(beitrag);

    let modal = document.getElementById("myModal");

    modal.style.display = "none";

    // console.log(e)
  };

  return (
    <>
      <div className="container_home">
        {/* <div> <input type="text" onChange={(e) => search(e.target.value)} /></div>
<div> <span style={{marginRight: '40px'}}>BranchenNews</span><span>{ search !== "" ? searchResult_news(1) : ''}</span> </div>

<div> <span style={{marginRight: '40px'}}>Pinnwand</span><span>{ search !== "" ? searchResult_news(4) : ''}</span> </div>
<div> <span style={{marginRight: '40px'}}>QM</span><span>{ search !== "" ? searchResult_files() : ''}</span> </div> */}

        <div id="wrapper">
          <Grid container className={classes.root}>
            <Grid
              container
              justify="center"
              id="updates"
              className={classes.griditem}
            >
              <div style={{ width: "100%" }}>
                <div
                  style={{ display: "flex", flexWrap: "wrap", width: "100%" }}
                >
                  <div className={classes.section_title}>
                    Neues im Intranet
                    <a onClick={() => showTour("ende")}>
                      <span
                        id="step4"
                        style={{
                          padding: "10px",
                          position: "absolute",
                          zIndex: "99",
                          backgroundColor: "orange",
                          display: "none",
                        }}
                      >
                        Die Neuigkeiten im Intranet
                      </span>
                    </a>
                  </div>
                  <div style={{ width: "100%" }}>
                    <div className={classes.rounded_corner_right}></div>
                    <div style={{ maxHeight: "310px", overflowY: "auto" }}>
                      {updatesHTML}
                    </div>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid className={classes.griditem} container justify="center">
              <div style={{ width: "100%" }}>
                <div className={classes.section_title}>unsere nachrichten</div>

                <div className={classes.rounded_corner_right}></div>

                <div
                  className={classes.DA_info_container}
                  style={{ marginBottom: "10px" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        width: "107px",
                        alignItems: "top",
                        marginRight: "8px",
                        fontWeight: "bold",
                      }}
                    >
                      <img
                        src={MockupCatering}
                        style={{ width: "100px" }}
                        alt="Catering"
                      />
                      Catering
                    </div>
                    <div
                      style={{
                        width: "100%",
                        maxHeight: "150px",
                        overflowY: "auto",
                      }}
                    >
                      {Cateringnews}
                    </div>
                  </div>
                </div>

                <div
                  style={{ display: "flex", flexWrap: "wrap", width: "100%" }}
                >
                  <div className={classes.section_title}></div>

                  <div className={classes.rounded_corner_right}></div>

                  <div className={classes.DA_info_container}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div
                        style={{
                          width: "107px",
                          alignItems: "top",
                          marginRight: "8px",
                          fontWeight: "bold",
                        }}
                      >
                        <img
                          src={MockupFacility}
                          style={{ width: "100px" }}
                          alt="Catering"
                        />
                        Reinigung/ Facility Management
                      </div>
                      <div
                        style={{
                          width: "100%",
                          maxHeight: "150px",
                          overflowY: "auto",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            maxHeight: "150px",
                            overflowY: "auto",
                          }}
                        >
                          {Reinigungnews}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid
              className={classes.griditem}
              container
              justify="center"
              id="branchennews"
            >
              <div
                style={{
                  display: "flow-root",
                  flexWrap: "wrap",
                  width: "100%",
                }}
              >
                <div className={classes.section_title}>branchennews</div>

                <div className={classes.rounded_corner_right}></div>

                <div className={classes.DA_info_container}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        width: "107px",
                        alignItems: "top",
                        marginRight: "8px",
                      }}
                    >
                      <img
                        src={MockupEssen}
                        style={{ width: "100px" }}
                        alt="Essen"
                      />
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        maxHeight: "340px",
                        overflowY: "auto",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#e8f2ec",
                          border: "1px solid #fff",
                          marginBottom: "5px",
                        }}
                      ></div>
                      {branchennews}
                    </div>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid className={classes.griditem} item id="pinnwand">
              {/* <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <div className={classes.section_title}>Pinnwand</div>
                  <div>
                    <div className={classes.rounded_corner_right}></div>

                    <div className={classes.DA_info_container}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <div
                          className="div_modal"
                          style={{
                            width: "107px",
                            alignItems: "top",
                            marginRight: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            Neues von mir
                          </span>
                          <a onClick={() => showTour("3")}>
                            <span
                              id="step2"
                              style={{
                                padding: "10px",
                                position: "absolute",
                                zIndex: "99",
                                backgroundColor: "orange",
                                display: "none",
                              }}
                            >
                              Teilen Sie Nachrichten mit Ihren Kollegen{" "}
                            </span>
                          </a>

                          <div
                            id="beitrag"
                            style={{
                              fontSize: "10px",
                              backgroundColor: "white",
                              border: "1px solid black",
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                              textAlign: "center",
                              padding: "12px",
                              color: "#000000",
                            }}
                            onClick={showModal}
                          >
                            <img
                              style={{ marginBottom: "5px", width: "30px" }}
                              src={Beitrag}
                            />
                            Beitrag erstellen
                          </div>
                        </div>
                        <div style={{ width: "100%" }}>
                          <span style={{ fontWeight: "bold" }}>
                            Aktuell geteilte Beiträge
                          </span>

                          <div
                            style={{
                              maxHeight: "150px",
                              overflowY: "auto",
                            }}
                          >
                            {kurznachrichten}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
                <div style={{ width: "100%", paddingTop: "10px" }}>
                  <div className={classes.section_title}>Termine</div>
                  <div>
                    <div className={classes.rounded_corner_right}></div>

                    <div className={classes.DA_info_container}>
                      <div style={{ width: "100%" }}>
                        <div
                          style={{
                            maxHeight: "120px",
                            overflowY: "auto",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </Grid>
          </Grid>
        </div>
        <div id="myModal" className="modal">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <p style={{ marginBottom: "25px" }} />

            <div
              style={{
                boxSizing: "border-box",
                width: "80%",
                height: "600px",
                border: "3px solid green",
                borderRadius: "20px",
                marginTop: "100px",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-35px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      border: "1px solid black",
                      background: "white",
                      height: "70px",
                      width: "90px",
                      borderRadius: "10px",
                    }}
                  >
                    <img src={BeitragIcon} alt="beitrag" />
                  </div>
                </div>
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  neues von mir
                </div>
                <div
                  style={{
                    display: "flex",
                    marginTop: "20px",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ width: "90%" }}>{user}</div>
                </div>
                <div style={{ marginTop: "20px", textAlign: "center" }}>
                  <input
                    style={{ fontWeight: "bold", width: "90%" }}
                    type="text"
                    name="topic"
                    onChange={count}
                    value={headline}
                    placeholder="Titel meines Beitrags"
                  />
                </div>
                <div
                  style={{
                    textAlign: "right",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "5px",
                  }}
                >
                  <div style={{ width: "90%" }}>{countTopic} / 35</div>
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      marginTop: "20px",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{ width: "91%" }}>
                      <CKEditor
                        editor={ClassicEditor}
                        onChange={handleChange}
                        data={newsText}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    textAlign: "right",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "5px",
                  }}
                >
                  <div style={{ width: "90%" }}></div>
                </div>

                <div style={{ marginTop: "20px", textAlign: "center" }}>
                  <input
                    onChange={changeLink}
                    style={{ width: "90%" }}
                    name="link"
                    type="text"
                    value={valueLink}
                    placeholder="https://"
                  />
                </div>
                {/* <div
                  style={{
                    display: "flex",s
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <div style={{ width: "90%" }}>
                    <input
                      type="file"
                      accept="image/*, application/pdf"
                      name="file"
                      onChange={(e) => {
                        let extension = e.target.files[0].type;
                        const reader = new FileReader();
                        var selectedFile = reader.readAsDataURL(
                          e.target.files[0]
                        );
                        reader.onload = async function () {
                          let databinary = reader.result;
                          console.log(databinary);
                          // var binarystring = databinary.toString();
                          // console.log(binarystring);
                          setUploadFile(databinary);
                        };

                        reader.onerror = (error) => {
                          //handle errors
                        };
                      }}
                    />
                  </div>
                </div> */}
                <div style={{ marginTop: "20px", textAlign: "center" }}>
                  <button
                    style={{
                      width: "120px",
                      height: "35px",
                      background: "green",
                      color: "white",
                      textTransform: "capitalize",
                    }}
                    onClick={handleSubmit}
                  >
                    {editMode === true ? "ändern" : "einstellen"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
